import { render, staticRenderFns } from "./rule-panel.vue?vue&type=template&id=dc0c77f4&scoped=true&"
import script from "./rule-panel.vue?vue&type=script&lang=ts&"
export * from "./rule-panel.vue?vue&type=script&lang=ts&"
import style0 from "./rule-panel.vue?vue&type=style&index=0&id=dc0c77f4&lang=less&scoped=true&"
import style1 from "./rule-panel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0c77f4",
  null
  
)

export default component.exports